/**
 * Created by forbiz on 2019-02-11.
 */

const reg = () => {
    const $document = $(document);

    const NumberRule = () => {
        $document
            .on('input', "[numberOnly]", function() {
                const $this = $(this);

                var onlyNumber = $this.val().replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
                $this.val(onlyNumber);
            });
    };

    // 로그인 체크박스
    const loginCheck = () => {
        const $chk = $('.login [type="checkbox"]');

        $chk
            .on('change', function() {
                const $this = $(this);

                if ( $this.prop('checked') == true ) {
                    $this.attr('data-check', 'y');
                } else {
                    $this.attr('data-check', 'n');
                }
            });
    }
 
    // 회원가입 - 성별 체크
    const genderToggle = () => {
        const $gender = $('input[name="gender"]');

        $gender
            .on('change', function() {
                const $this = $(this);

                if ( $this.prop('checked') == true ) {
                    $gender.attr('data-check', 'n');
                    $this.attr('data-check', 'y');
                } else {
                    $this.attr('data-check', 'n');
                }
            });
    };

    // 회원가입 - 건강정보 체크
    const healthToggle = () => {
        const $healthChk = $('.health-info__sec').find('input');

        $healthChk
            .on('change', function() {
                const $this = $(this);
            
                if ( $this.prop('checked') == true ) {
                    $this.attr('data-check', 'y');
                } else {
                    $this.attr('data-check', 'n');
                }
            })
    };

    const checkboxLoad = () => {
        const $checkbox = $('input[type="checkbox"]');
        const $radio = $('input[type="radio"]');

        if ( $checkbox.length > 0 || $radio.length > 0 ) {
            $.each($radio, function() {
                const $this = $(this);
        
                if( $this.is(':checked') ) $this.attr('data-checked', 'y');
                else $this.attr('data-checked', 'n');
            });

            $.each($checkbox, function() {
                const $this = $(this);
        
                if( $this.is(':checked') ) $this.attr('data-checked', 'y');
                else $this.attr('data-checked', 'n');
            });
        }
    }

    const regInit = () => {
        loginCheck();
        genderToggle();
        healthToggle();
        NumberRule();
        checkboxLoad();
    };

    regInit();
};

export default reg;